import React from 'react';

import { PhotoCamera as DefaultPhotoCameraIcon } from '@mui/icons-material';
import {
  Box,
  IconButton,
  styled
} from '@mui/material';
import {
  FileInputField,
  IFileData
} from 'modules/layer2';



const CameraIcon = styled(DefaultPhotoCameraIcon)({
  fontSize: 48,
  color: '#FFFFFF'
});


const AvatarContainer = styled(Box)(({ theme }) =>({
  backgroundColor: 'grey',
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

const StyledImage = styled('img')({
  position: 'absolute',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center'
});



export interface IProps {
  variant?: 'full' | 'thumbnail';
  value?: IFileData;
  initValue?: string;
  onChange: (data: IFileData) => void;
}

export const FC: React.FC<IProps> = props => {
  const imgSrc = props.value?.dataUrl ?? props.initValue ?? undefined;

  return (
    <FileInputField onSelectFile={fileData => props.onChange(fileData)}>
      {handleClick => (
        <AvatarContainer
          width={props.variant === 'full' ? 310 : 170}
          height={props.variant === 'full' ? 310 : 170}>
          {imgSrc && (
            <StyledImage
              src={imgSrc}
              alt="profile" />
          )}

          <IconButton
            onClick={handleClick}>
            <CameraIcon />
          </IconButton>
        </AvatarContainer>
      )}
    </FileInputField>
  );
};
